import React, { useState } from 'react';

function useAsyncError() {
  const [, setError] = useState();

  return (error) => {
    setError(() => {
      throw error;
    });
  };
}

export default useAsyncError;